import React from 'react';
import PropTypes from 'prop-types';

import TableRow from '@material-ui/core/TableRow';

import PreviewTableCellComponent from './previewTableCell.component';

const PreviewTableRowComponent = ({ row, headers }) => {
  const renderTableCells = () => headers.map(({ key }, index) => {
    return <PreviewTableCellComponent key={index} data={row[key]} />;
  });

  return (
    <TableRow
      hover
      tabIndex={-1}
    >
      {renderTableCells()}
    </TableRow>
  );
};

PreviewTableRowComponent.propTypes = {
  headers: PropTypes.shape([{
    key: PropTypes.string,
    name: PropTypes.string,
  }]).isRequired,
  row: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default PreviewTableRowComponent;
